import {
  BackInStockTriggerStep,
  TriggerStep,
} from "@redotech/redo-flows-common/advanced-flow-db-parser";
import { useTranslation } from "@redotech/redo-i18n";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo, useCallback, useState } from "react";
import { PartialWithRequiredType } from "../../steps";

export function backInStockTriggerStepIsValid(
  value: PartialWithRequiredType<BackInStockTriggerStep>,
): boolean {
  return true;
}

export const BackInStockFieldSelector = memo(function BackInStockFieldSelector({
  value,
  valueChange,
}: {
  value: PartialWithRequiredType<BackInStockTriggerStep>;
  valueChange: (value: PartialWithRequiredType<TriggerStep>) => void;
}) {
  const { t } = useTranslation();
  const setTriggerSpecificFields = useCallback(
    (
      triggerSpecificFields: PartialWithRequiredType<BackInStockTriggerStep>["triggerSpecificFields"],
    ) => {
      valueChange({
        ...value,
        triggerSpecificFields: {
          minimumInventoryThreshold:
            triggerSpecificFields?.minimumInventoryThreshold ??
            value.triggerSpecificFields?.minimumInventoryThreshold ??
            1,
        },
      });
    },
    [value, valueChange],
  );

  const [textValue, setTextValue_] = useState<string>(
    "" + (value.triggerSpecificFields?.minimumInventoryThreshold ?? 1),
  );
  const setTextValue = useCallback(
    (textValue: string) => {
      setTextValue_(textValue);
      const parsedValue = parseInt(textValue);
      if (isNaN(parsedValue) || parsedValue < 1) {
        return;
      }
      setTriggerSpecificFields({ minimumInventoryThreshold: parsedValue });
    },
    [setTriggerSpecificFields],
  );

  return (
    <Flex dir="column" gap="xl">
      <Text fontSize="xs" fontWeight="medium" textColor="secondary">
        {t("Minimum inventory threshold")}
      </Text>
      <Flex dir="column" gap="xs">
        <RedoTextInput
          inputTypeHint="number"
          min={1}
          onBlur={() => {
            if (
              !textValue ||
              isNaN(parseInt(textValue)) ||
              parseInt(textValue) < 1
            ) {
              setTextValue("1");
            }
          }}
          setValue={(textValue) => setTextValue(textValue)}
          value={textValue}
        />
        <Text fontSize="xxs" textColor="secondary">
          {t("Only trigger when stock levels reach or exceed this amount")}
        </Text>
      </Flex>
    </Flex>
  );
});
